import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { initAppType } from '@/model/global/actions';
import { makeSelectApplicationType } from '@/model/global/selectors';

const selectApplicationType = makeSelectApplicationType();

const withApplicationDetection = (Component: React.FC<{ [k in string]: unknown }>) => (
  props: { [k in string]: unknown },
): JSX.Element => {
  const [processing, setProcessing] = useState<'NOT_YET' | 'IN_PROGRESS' | 'FINISHED'>('NOT_YET');
  const dispatch = useDispatch();
  const applicationType = useSelector(selectApplicationType);
  useEffect(() => {
    if (processing === 'NOT_YET') {
      setProcessing('IN_PROGRESS');
      (async (): Promise<void> => {
        try {
          await initAppType()(dispatch);
        } finally {
          setProcessing('FINISHED');
        }
      })();
    }
  }, [dispatch, applicationType, processing]);
  return processing === 'FINISHED' ? <Component {...props} /> : <></>;
};

export default withApplicationDetection;
